import React, { ReactNode, useState } from 'react'
import styled, { createGlobalStyle } from 'styled-components'

import { AdminSidebar } from 'src/components/Sidebar/admin'
import Header from 'src/modules/admin/components/Header'
import Footer from 'src/components/Footer'

import { spacing } from '@material-ui/system'
import { Hidden, CssBaseline, Paper as MuiPaper, useTheme, useMediaQuery } from '@material-ui/core'

const drawerWidth = 260

const GlobalStyle = createGlobalStyle`
  html,
  body,
  #root {
    height: 100%;
  }

  body {
    background: ${(props) => props.theme.body.background};
  }

  .MuiCardHeader-action .MuiIconButton-root {
    padding: 4px;
    width: 28px;
    height: 28px;
  }
`

const Root = styled.div`
  display: flex;
  min-height: 100vh;
`

const Drawer = styled.div`
  ${(props) => props.theme.breakpoints.up('md')} {
    width: ${drawerWidth}px;
    flex-shrink: 0;
  }
`

const AppContent = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
`

const Paper = styled(MuiPaper)(spacing)

const MainContent = styled(Paper)`
  flex: 1;
  background: ${(props) => props.theme.body.background};

  @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {
    flex: none;
  }

  .MuiPaper-root .MuiPaper-root {
    box-shadow: none;
  }
`

interface Route {
  path: string
}

interface Props {
  children: ReactNode
  routes?: Route[]
}

export const AdminLayout = (props: Props) => {
  const { children, routes } = props
  const [mobileOpen, setMobileOpen] = useState(false)

  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen)
  }

  const theme = useTheme()
  const isLg = useMediaQuery(theme.breakpoints.up('lg'))

  return (
    <Root>
      <CssBaseline />
      <GlobalStyle />
      <Drawer>
        <Hidden mdUp implementation="js">
          <AdminSidebar
            routes={routes}
            PaperProps={{ style: { width: drawerWidth } }}
            variant="temporary"
            open={mobileOpen}
            onClose={handleDrawerToggle}
          />
        </Hidden>
        <Hidden smDown implementation="css">
          <AdminSidebar routes={routes} PaperProps={{ style: { width: drawerWidth } }} />
        </Hidden>
      </Drawer>
      <AppContent>
        <Header onDrawerToggle={handleDrawerToggle} />
        <MainContent p={isLg ? 10 : 5}>{children}</MainContent>
        <Footer />
      </AppContent>
    </Root>
  )
}
